<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>

        <v-text-field
            v-on:keyup.enter="searchOnEnter"
            v-on:blur="searchOnEnter"
            append-icon="mdi-magnify"
            hint="Kode, Deskripsi (press ENTER to search)"
            label="Search"
        ></v-text-field>
        <v-btn
            @click="showFilterDialog"
            icon fab
            color="blue"
            small
            class="ml-2"
        >
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-card-title>
      <v-expand-transition>
        <v-card class="mx-2 mb-1 elevation-0 color-top-left-gradient-3" v-show="showFilter===true">
          <v-card-text>

            <v-row >
              <v-col cols="12" sm="6" md="4">
                <v-flex class="d-flex justify-start">
              <span class="subtitle-2 mr-2">
                Rentang Tanggal
              </span>
                  <DateRangePicker
                      v-model="datePickerRange"
                      :locale-data="dprLocale"
                      @update="changeDatePickerRange"
                      :autoApply="dprAutoApply"
                      :showDropdowns="dprShowDropdowns"
                  ></DateRangePicker>
                </v-flex>
              </v-col>
              <v-col cols="6" sm="3" md="3">
                <v-btn color="primary" @click="runExtendedFilter" small >
                  Terapkan
                  <v-icon small class="ml-1" color="green lighten-2">mdi-filter</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>

          </v-card-text>
        </v-card>
      </v-expand-transition>
      <v-data-table
          v-model="selectedItems"
          :single-select="!multiSelect"
          :show-select="multiSelect"
          :headers="headers"
          :items="fVisitorsFiltered"
          :page.sync="currentPage"
          :items-per-page="pageSize"
          hide-default-footer
          class="elevation-0"
          @page-count="totalTablePages = totalPaginationPages"
      >
        <template v-slot:top>
          <v-row align="center" class="ml-4 mr-4">
            <v-switch
                v-model="multiSelect"
                :label="multiSelect ? 'Multi Select' : 'Single Select'"
                x-small
                class="pa-3"
            ></v-switch>
            <v-btn
                fab
                dark
                color="red accent-4"
                x-small
                :disabled="!multiSelect"
                class="mr-2"
                @click="deleteDialogMultiShow"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                fab
                dark
                color="green"
                x-small
                @click="showDialogNew"
                :disabled="multiSelect"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ index }">
          {{ index + (currentPage - 1) * pageSize + 1 }}
        </template>
        <template v-slot:[`item.logDate`]="{ item }">
          {{ computedDateFormattedDatefns(item.logDate)}}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="showDialogEdit(item)" icon :disabled="multiSelect">
            <v-icon small color="warning"> mdi-pencil </v-icon>
          </v-btn>

          <v-btn @click="deleteDialogShow(item)" icon :disabled="multiSelect">
            <v-icon small color="red accent-4"> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-container>
        <v-row justify="end" align="center">
          <v-col cols="4" md="2" sm="2">
            <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per page"
            ></v-select>
          </v-col>
          <v-col cols="10" md="9" sm="8" align="right">
            <v-pagination
                v-model="currentPage"
                :length="totalPaginationPages"
                total-visible="8"
                circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>

      <DeleteConfirmDialog
          ref="refDeleteConfirmDialog"
          @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
          @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
      ></DeleteConfirmDialog>

      <FVisitorDialog
          :formMode.sync="formMode"
          ref="refFormDialog"
          @eventFromFormDialogNew="saveDataNew"
          @eventFromFormDialogEdit="saveDataEdit"
      ></FVisitorDialog>

      <v-snackbar v-model="snackbar">
        {{ snackBarMesage }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-card>
    <v-card>
      <v-card-text >
        <div class="mx-4 rounded-lg pa-4">
          <v-row class="ml-0 py-2 px-2">
            <v-col cols="12" sm="12" md="12">
              <div>
                <v-form v-model="valid">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="2">
                      <v-autocomplete
                          outlined
                          v-model="year"
                          :items="itemsYear"
                          :rules="rulesNotEmtpy"
                          item-value="id"
                          item-text="text"
                          auto-select-first
                          dense
                          chips
                          deletable-chips
                          color="blue-grey lighten-2"
                          single-line
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-btn :disabled="!valid" block class="white--text" color="indigo" @click="calculateVisitor(year)">
                        Tampilkan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <div class="font-weight-bold text-center text-h5 my-3">
                TOTAL PENGUNJUNG TAHUN <span class="orange--text">{{yearText}}</span>
              </div>
              <v-data-table
                  :headers="headersTotal"
                  :items="fVisitorsTotal"
                  hide-default-footer
                  class="elevation-0"
              >

              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import FVisitorService from "../../../services/apiservices/f-visitor-service";
import FDivisionService from "../../../services/apiservices/f-division-service";

import DeleteConfirmDialog from "../../utils/DeleteConfirmDialog";

import FVisitorDialog from "./FVisitorDialog";
import FormMode from "../../../models/form-mode";
import FVisitor from "../../../models/f-visitor";
import FileService from "../../../services/apiservices/file-service";
import {format, parseISO} from "date-fns";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import FVisitorFilter from "../../../models/payload/f-visitor-filter";

export default {
  components: { FVisitorDialog, DeleteConfirmDialog, DateRangePicker },
  data() {
    return {
      fVisitorsTotal: [],
      headersTotal: [
        {text: 'Januari', value: 'january', align: 'center', sortable: false},
        {text: 'Februari', value: 'february', align: 'center', sortable: false},
        {text: 'Maret', value: 'march', align: 'center', sortable: false},
        {text: 'April', value: 'april', align: 'center', sortable: false},
        {text: 'Mei', value: 'may', align: 'center', sortable: false},
        {text: 'Juni', value: 'june', align: 'center', sortable: false},
        {text: 'Juli', value: 'july', align: 'center', sortable: false},
        {text: 'Agustus', value: 'august', align: 'center', sortable: false},
        {text: 'September', value: 'september', align: 'center', sortable: false},
        {text: 'Oktober', value: 'october', align: 'center', sortable: false},
        {text: 'November', value: 'november', align: 'center', sortable: false},
        {text: 'Desember', value: 'december', align: 'center', sortable: false},
      ],
      valid:false,
      year: new Date().getFullYear(),
      yearText: new Date().getFullYear(),
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
      itemsYear: [
        {id: 2023, text: '2023'},
        {id: 2024, text: '2024'},
        {id: 2025, text: '2025'},
        {id: 2026, text: '2026'},
        {id: 2027, text: '2027'},
        {id: 2028, text: '2028'},
        {id: 2029, text: '2029'},
        {id: 2030, text: '2030'},
      ],
      showFilter: true,
      title: "VISITOR",
      snackbar: false,
      snackBarMesage: "",

      multiSelect: false,
      selectedItems: [],

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 10,
      pageSizes: [10, 25, 50, 150, 500],

      search: "",
      headers: [
        { text: "No", value: "number", width: "7%" },
        { text: "Negara", value: "country", width: "16%" },
        { text: "Provinsi", value: "province", width: "16%" },
        { text: "Kota", value: "description", width: "16%" },
        { text: "Tanggal", value: "logDate", width: "16%" },
        { text: "Jumlah Pengujung", value: "visitorCount", width: "16%", align:"center" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      fVisitors: [new FVisitor(0, "", "")],
      itemsFDivision: [{ id: 0, kode1: "", description: "" }],
      itemsFSalesman: [],

      datePickerRange: {
        startDate: function(d){ d.setFullYear(d.getFullYear() - 1); return d}(new Date),
        endDate: new Date(),
      },
      dprLocale: {
        direction: 'ltr', //direction of text
        format: 'dd/mm/yyyy',
        separator: ' - ', //separator between the two ranges
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        // daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        // monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
      },
      dprAutoApply:true,
      dprShowDropdowns:true,
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (value) this.runExtendedFilter();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage == 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.runExtendedFilter();
        }
        // console.log("page size = " + value + " >> " + this.totalPages)
      },
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    fVisitorsFiltered() {
      return this.fVisitors;
    },
  },
  methods: {
    calculateVisitor(year){
      this.fVisitorsTotal = []
      let yearInt = parseInt(year)
      let startDateLong = new Date(yearInt - 1, 12, 1).getTime();
      let endDateLong = new Date(yearInt, 12, 31).getTime();
      FVisitorService.getVisitorCountByCityAndMonth(startDateLong, endDateLong).then((response) => {
        this.yearText = yearInt
        this.fVisitorsTotal.push({
          id: 1,
          january: 0,
          february: 0,
          march: 0,
          april: 0,
          may: 0,
          june: 0,
          july: 0,
          august: 0,
          september: 0,
          october: 0,
          november: 0,
          december: 0
        });

        response.data.forEach(item => {
          if (item.month === 1 && item.year === yearInt) this.fVisitorsTotal[0].january += item.totalVisitorCount;
          if (item.month === 2 && item.year === yearInt) this.fVisitorsTotal[0].february += item.totalVisitorCount;
          if (item.month === 3 && item.year === yearInt) this.fVisitorsTotal[0].march += item.totalVisitorCount;
          if (item.month === 4 && item.year === yearInt) this.fVisitorsTotal[0].april += item.totalVisitorCount;
          if (item.month === 5 && item.year === yearInt) this.fVisitorsTotal[0].may += item.totalVisitorCount;
          if (item.month === 6 && item.year === yearInt) this.fVisitorsTotal[0].june += item.totalVisitorCount;
          if (item.month === 7 && item.year === yearInt) this.fVisitorsTotal[0].july += item.totalVisitorCount;
          if (item.month === 8 && item.year === yearInt) this.fVisitorsTotal[0].august += item.totalVisitorCount;
          if (item.month === 9 && item.year === yearInt) this.fVisitorsTotal[0].september += item.totalVisitorCount;
          if (item.month === 10 && item.year === yearInt) this.fVisitorsTotal[0].october += item.totalVisitorCount;
          if (item.month === 11 && item.year === yearInt) this.fVisitorsTotal[0].november += item.totalVisitorCount;
          if (item.month === 12 && item.year === yearInt) this.fVisitorsTotal[0].december += item.totalVisitorCount;
        });
      })
    },
    showFilterDialog(){
      this.showFilter = !this.showFilter

      const itemPayload = Object
      itemPayload.dateFrom =  this.datePickerRange.startDate
      itemPayload.dateTo =  this.datePickerRange.endDate

    },
    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd-MM-yyyy") : "";
    },
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        //Krusial untuk search
        // console.log(`${event.target.value} vs ${this.search}`)
        this.currentPage = 1;
        this.search = event.target.value;
        this.runExtendedFilter();
      }
    },
    fetchParent() {
      if (this.currentUser.organizationLevel === "DIV") {
        FDivisionService.getFDivisionById(this.currentUser.fdivisionBean).then(
          (response) => {
            this.itemsFDivision = [response.data];
            // console.log(response.data.items)
          },
          (error) => {
            console.log(error.response);
          }
        );
      } else {
        FDivisionService.getAllFDivision().then(
          (response) => {
            // console.log(JSON.stringify(response.data))
            this.itemsFDivision = response.data;
          },
          (error) => {
            console.log(error.response);
          }
        );
      }
    },
    runExtendedFilter(){
      const fvisitorFilter = new FVisitorFilter()

      fvisitorFilter.dateFrom =  this.datePickerRange.startDate
      fvisitorFilter.dateTo =  this.datePickerRange.endDate
      fvisitorFilter.pageNo = this.currentPage
      fvisitorFilter.pageSize = this.pageSize
      fvisitorFilter.sortBy = "id"
      fvisitorFilter.order = "DESC"
      fvisitorFilter.search = this.search

      FVisitorService.getAllFVisitorContainingExt(fvisitorFilter).then(
          (response) => {
            const { items, totalPages } = response.data;
            this.fVisitors = items;
            this.totalPaginationPages = totalPages;
          },
          (error) => {
            console.log(error.response);
            if (error.response.status === 401) {
              this.snackBarMesage = "Anda tidak mempunyai Akses!!";
              this.snackbar = true;
            }
          }
      )
    },
    fetchFVisitor() {
      FVisitorService.getAllFVisitorContaining(
        this.currentPage,
        this.pageSize,
        "id",
        "DESC",
        this.search
      ).then(
        (response) => {
          // console.log(response.data.items)
          const { items, totalPages } = response.data;
          this.fVisitors = items;
          this.totalPaginationPages = totalPages;
        },
        (error) => {
          console.log(error.response);
          if (error.response.status === 401) {
            this.snackBarMesage = "Anda tidak mempunyai Akses!!";
            this.snackbar = true;
          }
        }
      );
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      // this.formDialogShow = true
      this.formMode = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemsFDivision
      );
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      this.closeDialog();
      /**
       * Setiap data baru harus terlihat
       */
      // this.fVisitors.push(this.itemSelected)
      // this.fVisitors = [itemFromRest].concat(this.fVisitors)
      // this.fVisitors.unshift(itemFromRest)
      this.runExtendedFilter();
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fVisitorsFiltered.indexOf(item);
      const itemModified = Object.assign({}, item);
      // this.formDialogShow = true
      this.formMode = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemsFDivision
      );
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      try {
        Object.assign(this.fVisitors[this.itemSelectedIndex], this.itemSelected);
      } catch (e) {
        this.runExtendedFilter();
        e.toString();
      }
      this.closeDialog();
    },

    deleteDialogShow(item) {
      // console.log(item)
      this.itemSelectedIndex = this.fVisitorsFiltered.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      // this.myConfirmDelete = true
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.username
      );
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        // console.log(`nilai ${this.selectedItems}`)
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
          this.selectedItems,
          `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fVisitors[this.itemSelectedIndex];
      FVisitorService.deleteFVisitor(deletedItem.id).then(
        () => {
          // console.log("hapus bos " + response.data + " >> " + this.itemSelectedIndex)
          this.fVisitors.splice(this.itemSelectedIndex, 1);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
    },
    changeDatePickerRange(){
      // console.log(`${this.datePickerRangeInv.startDate} >> ${this.datePickerRangeInv.endDate}`)
    },
    deleteItemConfirmedMultiSelect(items) {
      // console.log(okeMessage)
      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }
        // console.log("Item idex: " + itemIds)

        FVisitorService.deleteAllFVisitor(itemIds).then(
          (response) => {
            if (response.data) {
              for (let i = 0; i < items.length; i++) {
                if (
                  !response.data.includes(items[i].id) ||
                  response.data.length === 0
                ) {
                  const index = this.fVisitorsFiltered.indexOf(items[i]);
                  this.fVisitors.splice(index, 1);
                }
                if (response.data.length > 0) {
                  this.snackBarMesage = `${response.data.length} items gagal hapus (digunakan oleh data anak)`;
                  this.snackbar = true;
                }

                console.log(
                  "Undeleted Items: " + response.data + " = " + items[i].id
                );
              }
              this.closeDialog();
            }
          },
          (error) => {
            console.log("error " + error);
          }
        );

        // console.log(items)
        // FVisitorService.deleteAllFVisitors()
      }
    },
    closeDialog() {
      // this.myConfirmDialog = false
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FVisitor());
        this.itemSelectedIndex = -1;
      });
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },

    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    } else {
      this.runExtendedFilter();
      this.fetchParent();
      this.calculateVisitor(this.year);
    }
  },
};
</script>

<style scoped>
</style>